module.exports = __webpack_public_path__ + "static/media/BT.5d8bb188.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BT.svg
// module id = 2120
// module chunks = 7